import { render, staticRenderFns } from "./ReplyFiles.vue?vue&type=template&id=f8aff458&scoped=true"
import script from "./ReplyFiles.vue?vue&type=script&lang=js"
export * from "./ReplyFiles.vue?vue&type=script&lang=js"
import style0 from "./ReplyFiles.vue?vue&type=style&index=0&id=f8aff458&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8aff458",
  null
  
)

export default component.exports